module.exports = __webpack_public_path__ + "static/media/btn_point_ztop_pre.aae286a8.svg";